export enum ValveActivityEnum {
  SpecificSetpoint = 'specificSetpoint',
  Close = 'close',
  Open = 'open',
  Max = 'max',
  Min = 'min',
}
